const boxShadow = {
  inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
  share: "0px 4px 10px #D0D0D0",
}

module.exports = {
  boxShadow,
}

exports.default = boxShadow
